import React from 'react';
import { connect } from 'react-redux';
import {  Table,Modal, Row, Col, Spin, Form, Button, InputNumber, Icon } from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncUpdate, asyncGet } from './reducers';
import SetOrder from './setOrder.js';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;

class ResultShow extends React.Component {
    handleCancel = () => {
        this.props.modalHide();
        this.props.setValueInput('');
        this.props.setCommandStatus('');
        this.props.setMessage('');
    };
    handleOk = () => {
        this.props.modalHide();
        this.props.setValueInput('');
    };
    async changeId (Id) {
        await this.props.setValueInput(Id.target.value);
        this.changeSearchForm();
    }
    async  changeCommandStatus (status){
        await  this.props.setCommandStatus(status);
        this.changeSearchForm();
    }

    async  changeMessage(message){
        console.log(message);
        await this.props.setMessage(message.target.value);
        this.changeSearchForm();
    }

    changeSearchForm = () =>{
        let {selectedRowKeys} =  this.props.transferData;
        let sr = new Array();
        let arr = Array.from(selectedRowKeys);
        for(let child of arr){
            let flag =0;
            if(this.props.valueInput!=null&&this.props.valueInput!=undefined&&this.props.valueInput!=''&&!(child.clientId.indexOf(this.props.valueInput)>-1)){
                flag = 1;
            }
            if(this.props.commandStatus!=undefined && this.props.commandStatus!= -1 && this.props.commandStatus!= null && this.props.commandStatus!= '' &&  child.success != this.props.commandStatus){
                flag = 1;
            }
            if(this.props.message!=undefined&&this.props.message!=undefined&&this.props.message!=''&&!(child.msg.indexOf(this.props.message)>-1) ){
                flag = 1;
            }
            if(flag == 0){
                sr.push(child);
            }
        }
        this.props.getTransferDataCopy({selectedRowKeys1: sr});
        this.props.getTransferDataCopy({selectedRowKeys3: sr});
    }
    reGetDate = () =>{
        this.props.asyncGet();
        this.props.changeLoading();
    }
    sendCommend = () => {
        // 下发命令
        this.props.editShow({ isSendCommend: true });
    }
    onSelectChange = selectedRowKeys2 => {
        this.props.getTransferData({ selectedRowKeys2 });
    }
    render() {
        let { transferData } = this.props;
        const { selectedRowKeys2 } = transferData;
        const rowSelection = {
            selectedRowKeys2,
            onChange: this.onSelectChange,
        };
        let {selectedRowKeys1} =  this.props.transferDataCopy;
        let { isLoading ,resultShowStatus} = this.props.uiStatus;
          const columns = [
             {
                 title: '设备id',
                 dataIndex: 'clientId',
                 key: 'clientId',
                 render: (text, record) => {
                     return <span>{record.clientId}</span>;
                 },
             },
             {
                 title: 'success',
                 dataIndex: 'success',
                 key: 'success',
                 sorter: (a, b) => a.success - b.success,
                 render: (text,record) => {
                     return <span>{record.success == 0 ? '未知': record.success ==1 ? '成功': record.success ==2 ? "失败" : "领取"}</span>
                 }
             },
             {
                 title: 'message',
                 dataIndex: 'msg',
                 key: 'msg',
             }
         ];
         /*const content = (
             <Table
                 columns={columns}
                 dataSource={selectedRowKeys1}
                 pagination={false}
                 scroll={{ y: 500 }}
             />
         );*/
         const map = {"1":"成功","0":"未知","2":"失败","3":"领取","-1":"全部"};
        //value = {this.props.valueInput}
        //value = {this.props.commandStatus}
        // value = {this.props.message}
        return (
            <span>
                <Modal
                    width={800}
                    title="信息"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    visible={resultShowStatus}
                    confirmLoading={isLoading}
                    maskClosable={true}
                    footer={null}
                    okText="确定"
                    cancelText="取消">
                    <div>
                        <div>
                            设备id: &nbsp;<Input placeholder="请输入"  style={{ width: '20%' }}  onChange={this.changeId.bind(this)} value = {this.props.valueInput}/>
                            &nbsp;状态:&nbsp;<Select onChange={this.changeCommandStatus.bind(this)} style={{ width: '20%' }} value = {map[this.props.commandStatus]}>
                                    <Option value="1">成功</Option>
                                    <Option value="2">失败</Option>
                                    <Option value='0'>未知</Option>
                                    <Option value='3'>领取</Option>
                                    <Option value='-1'>全部</Option>
                                </Select>
                            &nbsp;message:&nbsp;<Input placeholder="请输入"  style={{ width: '20%' }} onChange={this.changeMessage.bind(this)} value = {this.props.message}/>
                            <Button type="danger" onClick={this.sendCommend} style={{ margin: '0 8px' }}>
                                下发命令
                            </Button>
                            <Icon
                                className='reload'
                                type="reload"
                                style={{
                                    cursor: 'pointer',
                                    fontSize: '20px',
                                    color: '#000',
                                    fontWeight: 'bold',
                                    float: 'right',
                                    marginTop: '5px',
                                    marginRight: '5px',
                                }}
                                onClick={this.reGetDate.bind(this)}
                            />
                        </div>
                        <Spin spinning={isLoading} tip="加载中..." style = {{marginLeft: '350px'}}></Spin>
                       <Table
                           columns={columns}
                           dataSource={selectedRowKeys1}
                           rowSelection={rowSelection}
                           pagination={false}
                           defaultExpandAllRows={false}
                           scroll={{ y: 500 }}
                       />
                    </div>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    uiStatus: state.commendList.uiStatus,
    transferData: state.commendList.transferData,
    transferDataCopy: state.commendList.transferDataCopy,
    valueInput: state.commendList.valueInput,
    commandStatus: state.commendList.commandStatus,
    message: state.commendList.message,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ resultShowStatus: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncGet: () => dispatch(asyncGet()),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    getTransferDataCopy: data => dispatch(actions.getTransferDataCopy(data)),
    setValueInput: data => dispatch(actions.setValueInput(data)),
    changeLoading: () => dispatch(actions.changeUiStatus({ isLoading: true })),
    editShow: params => dispatch(actions.changeUiStatus(params)),
    setCommandStatus: value => dispatch(actions.setCommandStatus(value)),
    setMessage: value => dispatch(actions.setMessage(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResultShow);



// WEBPACK FOOTER //
// ./pages/client/commendList/ResultShow.js